import { render, staticRenderFns } from "./campo-drag.vue?vue&type=template&id=1c32c741"
import script from "./campo-drag.vue?vue&type=script&lang=ts"
export * from "./campo-drag.vue?vue&type=script&lang=ts"
import style0 from "./campo-drag.vue?vue&type=style&index=0&id=1c32c741&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports